import { OnInit } from '@angular/core';
import { LoginService } from '../services/login.service';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { ThemeSettingService } from '../services/theme-setting.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { MessagePopupService } from '../services/message-popup.service';
var HomeComponent = /** @class */ (function () {
    function HomeComponent(loginService, globals, router, themeSettingService, workflowReturnService, messagePopupService) {
        this.loginService = loginService;
        this.globals = globals;
        this.router = router;
        this.themeSettingService = themeSettingService;
        this.workflowReturnService = workflowReturnService;
        this.messagePopupService = messagePopupService;
        this.isBusy = true;
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loaderConfig = this.themeSettingService.getTheme();
        this.isBusy = true;
        if (this.globals.Session) {
            this.loginService.getHomePage().subscribe(function (result) {
                _this.isBusy = false;
                var command = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(command, true, true);
            });
        }
        else {
            this.isBusy = false;
            this.router.navigate(['/', 'login']);
        }
    };
    return HomeComponent;
}());
export { HomeComponent };
